import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

type SvgProps = ComponentProps<"svg">;

const EventReisen = ({ className, ...props }: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("rotate-90", className)}
    {...props}
  >
    <path
      d="M7 3V6.11163C7 6.24955 6.92893 6.37774 6.812 6.45083L1.85467 9.54913C1.73771 9.62227 1.66667 9.75047 1.66667 9.88833V10.4877C1.66667 10.7479 1.91122 10.9389 2.16368 10.8757L6.50299 9.79093C6.75547 9.7278 7 9.91873 7 10.179V12.1518C7 12.2672 6.9502 12.3769 6.8634 12.4529L5.42321 13.713C5.11767 13.9804 5.35872 14.4803 5.75816 14.4076L7.92847 14.013C7.97573 14.0044 8.02427 14.0044 8.07153 14.013L10.2419 14.4076C10.6413 14.4803 10.8823 13.9804 10.5768 13.713L9.1366 12.4529C9.0498 12.3769 9 12.2672 9 12.1518V10.179C9 9.91873 9.24453 9.7278 9.497 9.79093L13.8363 10.8757C14.0888 10.9389 14.3333 10.7479 14.3333 10.4877V9.88833C14.3333 9.75047 14.2623 9.62227 14.1453 9.54913L9.188 6.45083C9.07107 6.37774 9 6.24955 9 6.11163V3C9 2.44771 8.55227 2 8 2C7.44773 2 7 2.44771 7 3Z"
      fill="currentColor"
    />
  </svg>
);

export default EventReisen;
